import React, { useState } from 'react';
import type { PersonalLiveToneSignalV1 } from '../types/liveInsights';

const TONE_CLASS: Record<string, string> = {
  constructive: 'zi-tone-constructive',
  neutral: 'zi-tone-neutral',
  negative: 'zi-tone-negative',
  contentious: 'zi-tone-negative',
  argumentative: 'zi-tone-negative',
  insufficient_evidence: 'zi-tone-neutral',
};

const TONE_LABEL: Record<string, string> = {
  constructive: 'Constructive',
  neutral: 'Neutral',
  negative: 'Negative',
  contentious: 'Contentious',
  argumentative: 'Argumentative',
  insufficient_evidence: 'Gathering data...',
};

interface Props {
  tone: PersonalLiveToneSignalV1;
}

export default function ViewerToneChip({ tone }: Props) {
  const [dismissed, setDismissed] = useState(false);
  const cls = TONE_CLASS[tone.status] ?? 'zi-tone-neutral';
  const label = TONE_LABEL[tone.status] ?? tone.status;
  const isGathering = tone.status === 'insufficient_evidence';
  // Auto-show coaching tip for non-constructive/non-neutral tones (actionable feedback)
  const showTip = !dismissed && tone.coachingTip && !isGathering;

  return (
    <div className={`zi-tone-chip ${cls}`}>
      <div className="zi-tone-header" onClick={() => setDismissed(!dismissed)}>
        <span className="zi-tone-label">{label}</span>
        {tone.intensity !== 'low' && !isGathering && (
          <span className="zi-tone-intensity">{tone.intensity}</span>
        )}
      </div>
      {showTip && (
        <div className="zi-tone-tip">{tone.coachingTip}</div>
      )}
    </div>
  );
}
